import axios from './axios';

const endPoint = '/e-cup';


export const create = (body) => {
    return axios.post(`${endPoint}`, {
        ...body
    });
};

export const registerEventTicketRegistration = (body) => {
    return axios.post(`${endPoint}/event-ticket-registration`, {
        fullName: body.fullName,
        email: body.email,
        phoneNumber: body.phoneNumber,
        signupForNews: !!body.signupForNews,
        ...(body.reCaptchaToken ? { reCaptchaToken: body.reCaptchaToken } : {})
    });
};

export const registerFootballTournamentRegistration = (body) => {
    return axios.post(`${endPoint}/football-tournament-registration`, body);
};